import { getDate, getHours, getMinutes } from "date-fns";
import {
  getCategory,
  getCurrentDay,
  getCurrentMonth,
} from "../../utils/getMethods";

const EventCard = (props: any) => {
  const { event, eventToggler, setEventSelected, setOnEdit } = props;

  const handleOnclick = () => {
    setEventSelected(event);
    setOnEdit(true);
    eventToggler.toggle();
  };

  const bgColor = getCategory(event.related_offer_category).bgColor;
  const textColor = getCategory(event.related_offer_category).textColor;
  const month = getCurrentMonth(event.starting_date).word;
  const dayWord = getCurrentDay(event.starting_date).word;
  const dayNumber = getDate(event.starting_date);
  /* const startingTime = `${getHours(event.starting_date)}:${getMinutes(
    event.starting_date
  )}`;
  const endingTime = `${getHours(event.ending_date)}:${getMinutes(
    event.starting_date
  )}`; */

  return (
    <div
      className="event-card"
      style={{ cursor: "pointer" }}
      onClick={handleOnclick}
    >
      <div
        className="event-card-day-box"
        style={{ backgroundColor: bgColor, cursor: "pointer" }}
      >
        <p className="event-card-day" style={{ cursor: "pointer" }}>
          {month}
        </p>
        <p className="event-card-day-number" style={{ cursor: "pointer" }}>
          {dayNumber}
        </p>
        <p className="event-card-day" style={{ cursor: "pointer" }}>
          {dayWord && dayWord.slice(0, 3)}
        </p>
      </div>
      <div className="event-card-specs-box" style={{ cursor: "pointer" }}>
        <p className="event-card-title" style={{ cursor: "pointer" }}>
          {event.related_offer_name}
        </p>
        <div
          className="event-card-time-box"
          style={{ backgroundColor: bgColor, cursor: "pointer" }}
        >
          <p
            className="event-card-time"
            style={{ color: textColor, cursor: "pointer" }}
          >
            {event.related_offer_category}
            {/* {`${startingTime} - ${endingTime}`} */}
          </p>
        </div>
      </div>
    </div>
  );
};
export default EventCard;
